import React, { useState } from "react";
import type { ReactElement } from "react";

import { Button } from "design_system/components/Button";
import { Select } from "design_system/components/Select";

import type { UrlTreePbu, UrlTreeProps } from "../../ds__types";
import { STATE_ABBR } from "../../../../common/utils/constants";
import UrlTreeOptions from "./url_tree_options";

const UrlTree = ({ statesList, statePbuMap }: UrlTreeProps): ReactElement => {
    const [selectedState, setSelectedState] = useState<string>("");
    const [selectedPbuId, setSelectedPbuId] = useState<number | null>(null);

    const handleSelectState = (e: React.ChangeEvent<HTMLSelectElement>): void => {
        setSelectedState(e.target.value);
        setSelectedPbuId(null);
    };

    const handleSelectPbu = (e: React.ChangeEvent<HTMLInputElement>): void => {
        const pbuId = parseInt(e.target.value);
        setSelectedPbuId(pbuId);
    };

    const handleButtonClick = (): void => {
        if (!selectedState) return;
        const pbuAddress = statePbuMap[selectedState]?.find(
            (pbu: UrlTreePbu) => pbu.id === selectedPbuId,
        )?.url;
        if (pbuAddress) {
            window.location.href = pbuAddress;
        }
    };

    const selectOptions = [
        { label: "Select one...", value: "" },
        ...statesList.map((state: string) => ({ label: STATE_ABBR[state], value: state })),
    ];

    const filteredPbus = selectedState ? statePbuMap[selectedState] : [];
    const pbuAddress = statePbuMap[selectedState]?.find(
        (pbu: UrlTreePbu) => pbu.id === selectedPbuId,
    )?.url;
    return (
        <>
            <div className="mt-24 text-gray-65657b text-0_875 font-500">
                {gettext("Select state:")}
            </div>
            <label className="cursor-pointer">
                <Select
                    name="state-list-dropdown"
                    value={selectedState}
                    onChange={handleSelectState}
                    options={selectOptions}
                    className="mt-8"
                />
            </label>
            {filteredPbus.length > 0 && (
                <UrlTreeOptions
                    filteredPbus={filteredPbus}
                    selectedPbuId={selectedPbuId}
                    handleSelectPbu={handleSelectPbu}
                />
            )}
            <a href={pbuAddress}>
                <Button
                    className="btn btn-primary mt-32 mb-32"
                    intent="primary"
                    onClick={handleButtonClick}
                    disabled={!selectedPbuId}
                >
                    {gettext("Find my provider")}
                </Button>
            </a>
        </>
    );
};
export default UrlTree;
